export default __webpack_public_path__ + "static/restaurant-presentation-18392d763428de6e7e2321e691ef4f22.png";